import Modal from "react-bootstrap/Modal";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Button from "react-bootstrap/Button";
import moment from "moment";
import "moment-timezone";

import IconBool from "components/IconBool";
import ConditionalRender from "components/ConditionalRender";
import CopyToClipTextarea from "components/copyToClipboard/CopyToClipTextarea";

const ModalViewPayload = ({show, setShow, item, _TC}) => {
    const handleClose = () => {
        setShow(false);
    };
    return (
        <Modal size="lg" show={show} onHide={handleClose} animation={true}>
            <Modal.Header closeButton className="preview-canvas mb-0">
                <div className="preview-icon">
                    <FontAwesomeIcon icon="microchip" />
                </div>
                <div className="preview-title">
                    <Modal.Title>
                        <div>
                            <div>{_TC("label.device")}</div>
                            <div>
                                <small className="h5">{item.uuid}</small>
                            </div>
                        </div>
                    </Modal.Title>
                </div>
            </Modal.Header>
            <Modal.Body>
                <div className="container-fluid mt-2">
                    <div className="row">
                        <div className="col-6">
                            <div>
                                <label>
                                    <strong>{_TC("label.format")}:</strong>{" "}
                                    {_TC("format.choice.b")}
                                </label>
                            </div>
                        </div>
                        <div className="col-6 text-end">
                            <div>
                                <ConditionalRender
                                    condition={item.ack_at.basic}
                                    fallback="-">
                                    <label className="me-2">
                                        <strong>{_TC("label.confirm")}:</strong>
                                    </label>
                                    <span>{moment(item.ack_at.basic).format("DD-MM-YYYY HH:mm")}</span>
                                </ConditionalRender>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-12">
                            <CopyToClipTextarea value={item.config.basic} rows="3" />
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-6">
                            <div>
                                <label>
                                    <strong>{_TC("label.format")}:</strong>{" "}
                                    {_TC("format.choice.a")}
                                </label>
                            </div>
                        </div>
                        <div className="col-6 text-end">
                            <div>
                                <ConditionalRender
                                    condition={item.ack_at.advanced}
                                    fallback="-">
                                    <label className="me-2">
                                        <strong>{_TC("label.confirm")}:</strong>
                                    </label>
                                    <span>{moment(item.ack_at.advanced).format("DD-MM-YYYY HH:mm")}</span>
                                </ConditionalRender>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-12">
                            <CopyToClipTextarea value={item.config.advanced} rows="3" />
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default ModalViewPayload;
